import invariant from 'invariant';
import queryString from 'query-string';
import authenticatedRequest from '../authenticatedRequest';
import labelRequest from '../labelRequest';

export default function getRecommendations(params) {
    let { baseUrl, recommendationsKey, brandId, country, partNumber, uberToken, clientId, clientSecret, options, originalOutfit } = params;

    invariant(baseUrl, 'baseUrl is a required param of getRecommendations()');
    invariant(recommendationsKey, 'recommendationsKey is a required param of getRecommendations()');
    invariant(brandId, 'brandId is a required param of getRecommendations()');
    invariant(country, 'country is a required param of getRecommendations()');
    invariant(partNumber, 'partNumber is a required param of getRecommendations()');
    invariant(clientId, 'clientId is a required param of getRecommendations()');

    const localisedBrand = `${brandId}_${country?.toLowerCase()}`;
    const queries = queryString.stringify({
        variantId: partNumber,
        locale: options?.locale,
        store: localisedBrand,
        originalOutfit,
    });
    
    const assertedBrandId = brandId === 'theoutnet' ? 'ton' : brandId;

    const concatUrl = `${baseUrl}styling/${recommendationsKey}/v1/${assertedBrandId}?${queries}`;

    return labelRequest(authenticatedRequest(new Request(concatUrl), uberToken, clientId, clientSecret), 'getRecommendations');
}
